import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { gateway_recommendation_type } from "../../enums";
import {
  useAccountSettings,
  useAuth,
  useHookForm,
  useMerchantApiMutation,
} from "../../hooks";
import {
  IAccountDetailsSettings,
  StatusColors,
} from "../../interfaces-and-types";
import { globalHandlerUtils } from "../../utils";
import { accountDetailsValidationSchema } from "./validationSchema";

import { View } from "./View";

export const AccountDetails = () => {
  const { active_tenant_id } = useAuth();
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  const merchantHandleAlreadyExists = accountSettings?.merchant_handle !== null;

  useEffect(() => {
    accountSettings &&
      reset({
        ...accountSettings,
        merchant_handle: accountSettings.merchant_handle?.replace("@", ""),
      });
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      accountSettings &&
        reset({
          ...accountSettings,
          merchant_handle: accountSettings.merchant_handle?.replace("@", ""),
        });
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: IAccountDetailsSettings = {
    merchant_name: "",
    merchant_handle: null,
    country: "",
    phone_number: "",
    time_zone: "",
    // account_status: "active",

    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation<IAccountDetailsSettings, IAccountDetailsSettings>(
      "saveAccountDetailsSettings"
    ).usePutMutation;

  const handleApiSubmit = (data: IAccountDetailsSettings) => {
    saveSettings({
      ...data,

      // clear the bvn & nin fields for form submission
      bvn: data.bvn?.includes("*") ? undefined : data.bvn ?? undefined,
      nin: data.bvn?.includes("*") ? undefined : data.nin ?? undefined,
    });
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset, watch, control } =
    useHookForm({
      initialFormValues,
      validationSchema: accountDetailsValidationSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    });

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const goBack = () => navigate("/settings");

  const deactivateAccount = () => {
    if (window.confirm("Are you sure you want to deactivate your account?"))
      alert(
        "Request for deactivation sent. Account will be deactivated within 7 days..."
      );
  };

  const unactivated = !accountSettings?.is_account_activation_requested;
  const awaitingVerification =
    accountSettings?.is_account_activation_requested &&
    !accountSettings.is_account_verification_completed;
  const activated =
    accountSettings?.is_account_verification_completed &&
    accountSettings.is_account_verification_successful;

  const account_statusBadgeInfo: { text: string; statusColor: StatusColors } = {
    text: unactivated
      ? "Unactivated"
      : awaitingVerification
      ? "Awaiting Verification"
      : "Activated",
    statusColor: unactivated
      ? "danger"
      : awaitingVerification
      ? "teal"
      : "success",
  };

  return (
    <View
      merchantId={active_tenant_id || ""}
      isVerifiedMerchant={
        accountSettings?.is_account_verification_successful || false
      }
      isNigerianMerchant={accountSettings?.country === "NG"}
      isBvnProvided={accountSettings?.is_bvn_provided || false}
      isNinProvided={accountSettings?.is_nin_provided || false}
      isVerificationRequested={
        accountSettings?.is_account_activation_requested || true
      }
      accountStatusBadgeInfo={account_statusBadgeInfo}
      deactivateAccount={deactivateAccount}
      goBack={goBack}
      isDirty={isDirty}
      merchantHandleAlreadyExists={merchantHandleAlreadyExists}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
      control={control}
    />
  );
};
